<template>
    <section class="padding-vertical-content lightgray-content mb-3 mb-lg-4">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="nombre">{{$t("formularios.nombre_completo") + " *"}}</label>
                                    <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                                        <input id="nombre" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.nombre_completo')" v-model="acreditacion.nombre" />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="dni">{{$t("formularios.dni") + " *"}}</label>
                                    <ValidationProvider name="dni" rules="required" v-slot="{ errors }">
                                        <input id="dni" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.dni')" v-model="acreditacion.dni" />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="email">{{$t("formularios.email") + " *"}}</label>
                                    <ValidationProvider name="email" rules="required" v-slot="{ errors }">
                                        <input id="email" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.email')" v-model="acreditacion.email" />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="telefono">{{$t("formularios.telefono") + " *"}}</label>
                                    <ValidationProvider name="telefono" rules="required" v-slot="{ errors }">
                                        <input id="telefono" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.telefono')" v-model="acreditacion.telefono" />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="medio">{{$t("formularios.medio") + " *"}}</label>
                                    <ValidationProvider name="medio" rules="required" v-slot="{ errors }">
                                        <input id="medio" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.medio')" v-model="acreditacion.medio" />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="evento">{{$t("formularios.seleciona_el_evento") + " *"}}</label>
                                    <ValidationProvider name="evento" rules="required" v-slot="{ errors }">
                                        <multiselect
                                            v-model="event"
                                            :options="eventos"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Seleccione el evento"
                                            label="name"
                                            track-by="id"
                                            id="slect-evento"
                                            :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            "
                                        ></multiselect>
                                        <span v-if="errors[0]" class="error invalid-feedback is-invalid" style="display: block;">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        esMovil: {
            type: Boolean,
            default: false
        },
        events: {
            type: Object,
            default: () => {}
        },
        acreditacion: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            eventos: [],
            event: {}
        };
    },
    created() {
        this.getEventos();
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.acreditacion.evento_id = this.event.id
                this.$emit('submit', this.acreditacion);
            }
        },
        getEventos() {
            let params = {filters: {tid : this.configuracion.hash_teatro}};

            this.$store.dispatch(this.config.getVuexAlias('front.events.select'), params).then(res => {
                this.eventos = res.data.data;
            })
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
    },
};
</script>